
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { nameInfoType } from "@/types/Application/CommonInformation";
import { expensesFSDataInfoType } from '@/types/Application/FinancialStatement';

@Component({
    components:{
        UnderlineForm,
        CheckBox       
    }
})
export default class Form4Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false; 

    housing = {}; 
    food = {};
    transport = {};
    clothing = {};
    health = {};
    children = {};
    miscellaneous = {};
    premiums = {};
    tax = {};
    other = {};
    totalExpenses = {};
    otherDesc = '';

    debt = [];
    totalDebt = 0;
    
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;        
    }
   
    public extractInfo(){        
        this.getExpenseInfo();  
        this.getDebtInfo();
    } 

    public getExpenseInfo(){    
        
        this.housing = {
            'Rent/mortgage': {},
            'Property taxes and strata fees': {},
            'Utilities': {},
            'Homeowner/renter’s insurance': {},
            'Home maintenance and repair': {},
            'Other': {},
            'Total': {}
        };
        this.food = {
            'Groceries': {},
            'Eating out': {},
            'Household supplies': {},
            'Other': {},
            'Total': {}
        };
        this.transport = {
            'Car insurance and car loan payments': {},
            'Fuel': {},
            'Maintenance and repairs': {},
            'Public transit, taxis and parking': {},
            'Other': {},
            'Total': {}
        };
        this.clothing = {};
        this.health = {};
        this.children = {};
        this.miscellaneous = {};
        this.premiums = {};
        this.tax = {};
        this.other = {};
        this.totalExpenses = {};
        this.otherDesc = '';

        if (this.result?.expensesFSSurvey) {
            const expenseInfo: expensesFSDataInfoType = this.result.expensesFSSurvey;

            this.otherDesc = expenseInfo.otherDesc?expenseInfo.otherDesc:'';
            
            if(expenseInfo.children && expenseInfo.children.length>0){
                this.children = { 
                    yearlyAmount: expenseInfo.children[0]?.yearlyAmount?expenseInfo.children[0].yearlyAmount:0,
                    monthlyAmount: expenseInfo.children[0]?.monthlyAmount?expenseInfo.children[0].monthlyAmount:0
                }
            }

            if(expenseInfo.clothing && expenseInfo.clothing.length>0){
                this.clothing = { 
                    yearlyAmount: expenseInfo.clothing[0]?.yearlyAmount?expenseInfo.clothing[0].yearlyAmount:0,
                    monthlyAmount: expenseInfo.clothing[0]?.monthlyAmount?expenseInfo.clothing[0].monthlyAmount:0
                }
            }            
            
            if(expenseInfo.food && expenseInfo.food.length>0){
                let monthTotal = 0;
                for(const food of expenseInfo.food) {                    
                    if(food.amountName){                       
                        this.food[food.amountName] = {
                            monthlyAmount: food.monthlyAmount?food.monthlyAmount:0,
                            yearlyAmount: food.yearlyAmount?food.yearlyAmount:0
                        };
                        monthTotal = monthTotal + Number(food.monthlyAmount);                       
                    }                    
                }
                this.food['Total'] = {
                    monthlyAmount: monthTotal,
                    yearlyAmount: monthTotal * 12
                };

            }

            if(expenseInfo.health && expenseInfo.health.length>0){
                this.health = { 
                    yearlyAmount: expenseInfo.health[0]?.yearlyAmount?expenseInfo.health[0].yearlyAmount:0,
                    monthlyAmount: expenseInfo.health[0]?.monthlyAmount?expenseInfo.health[0].monthlyAmount:0
                }
            }  

            if(expenseInfo.housing && expenseInfo.housing.length>0){
                let monthTotal = 0;
                for(const housing of expenseInfo.housing) {                    
                    if(housing.amountName){                       
                        this.housing[housing.amountName] = {
                            monthlyAmount: housing.monthlyAmount?housing.monthlyAmount:0,
                            yearlyAmount: housing.yearlyAmount?housing.yearlyAmount:0
                        };
                        monthTotal = monthTotal + Number(housing.monthlyAmount);                       
                    }                    
                }
                this.housing['Total'] = {
                    monthlyAmount: monthTotal,
                    yearlyAmount: monthTotal * 12
                };

            }

            if(expenseInfo.miscellaneous && expenseInfo.miscellaneous.length>0){
                this.miscellaneous = { 
                    yearlyAmount: expenseInfo.miscellaneous[0]?.yearlyAmount?expenseInfo.miscellaneous[0].yearlyAmount:0,
                    monthlyAmount: expenseInfo.miscellaneous[0]?.monthlyAmount?expenseInfo.miscellaneous[0].monthlyAmount:0
                }
            } 

            if(expenseInfo.other && expenseInfo.other.length>0){
                this.other = { 
                    yearlyAmount: expenseInfo.other[0]?.yearlyAmount?expenseInfo.other[0].yearlyAmount:0,
                    monthlyAmount: expenseInfo.other[0]?.monthlyAmount?expenseInfo.other[0].monthlyAmount:0
                }
            } 

            if(expenseInfo.premiums && expenseInfo.premiums.length>0){
                this.premiums = { 
                    yearlyAmount: expenseInfo.premiums[0]?.yearlyAmount?expenseInfo.premiums[0].yearlyAmount:0,
                    monthlyAmount: expenseInfo.premiums[0]?.monthlyAmount?expenseInfo.premiums[0].monthlyAmount:0
                }
            } 

            if(expenseInfo.tax && expenseInfo.tax.length>0){
                this.tax = { 
                    yearlyAmount: expenseInfo.tax[0]?.yearlyAmount?expenseInfo.tax[0].yearlyAmount:0,
                    monthlyAmount: expenseInfo.tax[0]?.monthlyAmount?expenseInfo.tax[0].monthlyAmount:0
                }
            }

            if(expenseInfo.total && expenseInfo.total.length>0){
                this.totalExpenses = { 
                    yearlyAmount: expenseInfo.total[0]?.yearlyAmount?expenseInfo.total[0].yearlyAmount:0,
                    monthlyAmount: expenseInfo.total[0]?.monthlyAmount?expenseInfo.total[0].monthlyAmount:0
                }
            }

            if(expenseInfo.transport && expenseInfo.transport.length>0){
                let monthTotal = 0;
                for(const transport of expenseInfo.transport) {                    
                    if(transport.amountName){                       
                        this.transport[transport.amountName] = {
                            monthlyAmount: transport.monthlyAmount?transport.monthlyAmount:0,
                            yearlyAmount: transport.yearlyAmount?transport.yearlyAmount:0
                        };
                        monthTotal = monthTotal + Number(transport.monthlyAmount);                       
                    }                    
                }
                this.transport['Total'] = {
                    monthlyAmount: monthTotal,
                    yearlyAmount: monthTotal * 12
                };
            }
        }
    }

    public getDebtInfo(){ 

        const emptyDebt = {
            creditor:'',
            reason:'',
            balanceOwing: ''
        };

        this.debt = [];    
        this.totalDebt = 0;   
        
        if(this.result?.debtsFSSurvey){  
            let totalDebtAmount = 0;          

            for(const debtSurvey of this.result.debtsFSSurvey){
                let debtInfo = {
                    creditor: debtSurvey.creditorName?debtSurvey.creditorName:'',
                    reason: debtSurvey.reasonForBorrowing?debtSurvey.reasonForBorrowing:'',
                    balanceOwing: debtSurvey.balanceOwing?debtSurvey.balanceOwing:0
                };
                this.debt.push(debtInfo);
                totalDebtAmount = totalDebtAmount + Number(debtInfo.balanceOwing);                
            } 

            this.totalDebt = totalDebtAmount;
        }

        if(this.debt.length == 0){
            this.debt.push(emptyDebt);
        }            
    }
 
}
